import { defineMessages } from 'react-intl';

const scope = 'app.containers.admin.AccountManagement.Recommendations';

export default defineMessages({
    title: {
        id: `${scope}.title`,
        defaultMessage: 'Actioned Recommendations',
    },
    description: {
        id: `${scope}.description`,
        defaultMessage: 'Recommendations that have been actioned in the last month - click for more detail',
    },
    nameColumnTitle: {
        id: `${scope}.nameColumnTitle`,
        defaultMessage: 'Property',
    },
    totalColumnTitle: {
        id: `${scope}.totalColumnTitle`,
        defaultMessage: 'Total',
    },
    acceptedColumnTitle: {
        id: `${scope}.acceptedColumnTitle`,
        defaultMessage: 'Accepted',
    },
    autoAcceptedColumnTitle: {
        id: `${scope}.autoAcceptedColumnTitle`,
        defaultMessage: 'Auto-Accepted',
    },
    declinedColumnTitle: {
        id: `${scope}.declinedColumnTitle`,
        defaultMessage: 'Declined',
    },
    overtypedColumnTitle: {
        id: `${scope}.overtypedColumnTitle`,
        defaultMessage: 'Overtyped',
    },
    overtypedTotalColumnTitle: {
        id: `${scope}.overtypedTotalColumnTitle`,
        defaultMessage: 'Net Overtyped',
    },
    exportButton: {
        id: `${scope}.exportButton`,
        defaultMessage: 'Export all data',
    },
});
